import { Stack } from '@mui/material'
import { preview } from '@/components/form/preview'
import { useOrderPriorityTexts } from '@/intl'
import {
  ExpandLess,
  ExpandMore,
  KeyboardDoubleArrowDown,
  KeyboardDoubleArrowUp,
  UnfoldMore,
} from '@mui/icons-material'
import { useTexts } from './hooks/useTexts'
import { BulkViewData } from '../../hooks/useBulkViewData/types'

type Props = {
  bulkData: BulkViewData
}

export function Priority(props: Props) {
  const {
    bulkData: { priority },
  } = props

  const texts = useTexts()
  const { getPriorityText } = useOrderPriorityTexts()

  if (priority === 'mixed') {
    return (
      <preview.Field label={texts.priority.label}>
        <preview.MixValue />
      </preview.Field>
    )
  }

  return (
    <preview.Field label={texts.priority.label}>
      <Stack direction="row" alignItems="center" gap={1} flexGrow={1}>
        <PriorityIcon priority={priority} />
        {getPriorityText(priority)}
      </Stack>
    </preview.Field>
  )
}

type PriorityIconProps = {
  priority: uui.domain.server.rm.BaseOrder['priority']
}

function PriorityIcon(props: PriorityIconProps) {
  const { priority } = props

  switch (priority) {
    // highest priority
    case 20:
      return <KeyboardDoubleArrowUp sx={{ color: t => t.vars.palette.error.main }} />

    // higher priority
    case 10:
      return <ExpandLess sx={{ color: t => t.vars.palette.warning.main }} />

    // normal priority
    case 0:
      return <UnfoldMore sx={{ color: t => t.vars.palette.action.active }} />

    // lower priority
    case -10:
      return <ExpandMore sx={{ color: t => t.vars.palette.info.main }} />

    // lowest priority
    case -20:
      return <KeyboardDoubleArrowDown sx={{ color: t => t.vars.palette.success.main }} />
  }
}
